import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { TripTransferQuery } from '../gql/graphql';

const tripTransfer = graphql(/* GraphQL */ `
  query tripTransfer($tripId: Int!) {
    tripTransfer(tripId: $tripId) {
      embarkationTime
      disembarkationTime
      returnAirportName
      returnAirportCode
      departureAirportName
      departureAirportCode
      returnPierName
      departurePierName
    }
  }
`);

const useGetTripTransfer = (tripId: number, shouldFetch: boolean) => {
  const { data, isLoading } = useQuery<TripTransferQuery>({
    queryKey: ['tripTransfer', tripId],
    queryFn: async () =>
      graphqlRequest<TripTransferQuery>(tripTransfer, {
        tripId,
      }), // Public endpoint, no auth needed
    enabled: shouldFetch,
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    tripTransfer: data,
    tripTransferLoading: isLoading,
  };
};

export default useGetTripTransfer;
